import { TableEvent } from '@baemingo/table-events';
import { ReportEvent } from '@baemingo/report-events';
import { CashEvent } from '@baemingo/cash-events';
import { SERVICE_TYPE } from '~../__queries__/globalTypes';
import {
  CartItem,
  Languages,
  Station,
  AuthToken,
  Locale,
  POSItemsIdsState,
  User,
  Zone,
  Optional,
  CountryCode,
} from '~Types';
import {
  getCompany_Venue_company_predefinedReasons,
  getCompany_Venue_company_staffs,
  getCompany_Venue_predefinedMessages,
} from '~../src/Scenes/Venue/__queries__/getCompany';
import {
  GetTables_Venue_floorPlans,
  GetTables_Venue_floorPlans_tables,
} from '~../src/Scenes/Venue/__queries__/GetTables';
import { InventoryEvent } from '@baemingo/inventory-events';
import { CourseType, CreatePOSOrder, ErrorCase, Meta, PosMode, Printer } from '~reducers';
import { OrderStatusEvent } from '@baemingo/order-status-events/dist';
import { v4 as uuid } from 'uuid';
import { DeviceSettingsEvent } from '@baemingo/device-settings-events/dist/types';
import { PrintRow, PrintType } from '~Components/PrinterManager';

export const TOGGLE_MAIN_MENU = 'TOGGLE_MAIN_MENU';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_DAILY_TOTAL = 'SET_DAILY_TOTAL';
export const SET_ORDERS_COUNT = 'SET_ORDERS_COUNT';
export const USER_PROVIDED_INPUT = 'USER_PROVIDED_INPUT';
export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const DEFAULT_LOCALE = 'en';
export const NEW_INCOMING_ORDER = 'NEW_INCOMING_ORDER';
export const SET_ORDER_DETAILS_ID = 'SET_ORDER_DETAILS_ID';
export const SET_COLLAPSED_TABLE = 'SET_COLLAPSED_TABLE';
export const UNSET_COLLAPSED_TABLE = 'UNSET_COLLAPSED_TABLE';
export const SET_CONNECTION_STATUS = 'SET_CONNECTION_STATUS';
export const SOCKET_PONG_RECEIVED = 'SOCKET_PONG_RECEIVED';
export const SOCKET_CONNECTION_LOST = 'SOCKET_CONNECTION_LOST';
export const SET_USER = 'SET_USER';
export const SET_ACTIVE_INTEGRATIONS = 'SET_ACTIVE_INTEGRATIONS';
export const SET_COMPANY = 'SET_COMPANY';
export const SET_COMPANY_NAME = 'SET_COMPANY_NAME';
export const SET_POS_ITEMS_IDS = 'SET_POS_ITEMS_IDS';
export const SET_POS_DEVICE_IDS = 'SET_POS_DEVICE_IDS';
export const POS_STAFF_LOGIN = 'POS_STAFF_LOGIN';
export const POS_STAFF_LOGOUT = 'POS_STAFF_LOGOUT';
export const SET_COMPANY_STAFF = 'SET_COMPANY_STAFF';
export const RESET_COMPANY_STAFF = 'RESET_COMPANY_STAFF';
export const SET_STATIONS = 'SET_STATIONS';
export const SET_STATION = 'SET_STATION';
export const RESET_STATION = 'RESET_STATION';
export const SET_ZONES = 'SET_ZONES';
export const SET_FLOOR_PLANS = 'SET_FLOOR_PLANS';
export const SET_TABLES = 'SET_TABLES';
export const SET_PREDEFINED_MESSAGES = 'SET_PREDEFINED_MESSAGES';
export const SET_COURSE_TYPES = 'SET_COURSE_TYPES';
export const CREATE_POS_ORDER = 'CREATE_POS_ORDER';
export const UPDATE_POS_ORDER = 'UPDATE_POS_ORDER';
export const SET_VENUE_ID = 'SET_VENUE_ID';
export const ADD_ITEM_TO_POS_ORDER = 'ADD_ITEM_TO_POS_ORDER';
export const REMOVE_ITEM_FROM_POS_ORDER = 'REMOVE_ITEM_FROM_POS_ORDER';
export const REMOVE_LEGAL_ITEMS_FROM_POS_ORDER = 'REMOVE_LEGAL_ITEMS_FROM_POS_ORDER';
export const SET_MODULES_WEBPAGE = 'SET_MODULES_WEBPAGE';
export const POS_PAYMENT_REQUEST = 'POS_PAYMENT_REQUEST';
export const OVERRIDE_POS_PAYMENT_METHOD = 'OVERRIDE_POS_PAYMENT_METHOD';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const MESSAGE_VOLUME_CHANGE = 'MESSAGE_VOLUME_CHANGE';
export const MESSAGE_VERSION = 'MESSAGE_VERSION';
export const MESSAGE_AUTH_TOKEN = 'MESSAGE_AUTH_TOKEN';
export const MESSAGE_DEVICE_ID = 'MESSAGE_DEVICE_ID';
export const MESSAGE_DEVICE_OS = 'MESSAGE_DEVICE_OS';
export const MESSAGE_PRINTERS = 'MESSAGE_PRINTERS';
export const ADD_VIRTUAL_TEST_PRINTER = 'ADD_VIRTUAL_TEST_PRINTER';
export const REFUND_BRIDGE_REQUEST = 'REFUND_BRIDGE_REQUEST';
export const REFUND_BRIDGE_REQUEST_SENT = 'REFUND_BRIDGE_REQUEST_SENT';
export const MESSAGE_REFUND_BRIDGE_REQUEST_FAILED = 'MESSAGE_REFUND_BRIDGE_REQUEST_FAILED';
export const MESSAGE_REFUND_BRIDGE_REQUEST_SUCCESS = 'MESSAGE_REFUND_BRIDGE_REQUEST_SUCCESS';
export const PAYMENT_BRIDGE_REQUEST = 'PAYMENT_BRIDGE_REQUEST';
export const PAYMENT_BRIDGE_REQUEST_SENT = 'PAYMENT_BRIDGE_REQUEST_SENT';
export const MESSAGE_PAYMENT_BRIDGE_REQUEST_FAILED = 'MESSAGE_PAYMENT_BRIDGE_REQUEST_FAILED';
export const MESSAGE_PAYMENT_BRIDGE_REQUEST_SUCCESS = 'MESSAGE_PAYMENT_BRIDGE_REQUEST_SUCCESS';
export const MESSAGE_PRINTER_MESSAGE = 'MESSAGE_PRINTER_MESSAGE';
export const MESSAGE_AVAILABLE_PRINTERS = 'MESSAGE_AVAILABLE_PRINTERS';
export const TABLE_PAID = 'TABLE_PAID';
export const OPEN_TABLE = 'OPEN_TABLE';
export const SEND_TABLE_ITEMS = 'SEND_TABLE_ITEMS';
export const MESSAGE_RECEIPT_COUNTER = 'MESSAGE_RECEIPT_COUNTER';
export const PRINT_RECEIPT = 'PRINT_RECEIPT';
export const INCREASE_RECEIPT_COUNTER = 'INCREASE_RECEIPT_COUNTER';
export const MESSAGE_POS_LAYOUT = 'MESSAGE_POS_LAYOUT';
export const SET_POS_LAYOUT = 'SET_POS_LAYOUT';
export const SET_POS_LAYOUTS = 'SET_POS_LAYOUTS';
export const HALT_BONG_PRINTING = 'HALT_BONG_PRINTING';
export const RESUME_BONG_PRINTING = 'RESUME_BONG_PRINTING';
export const SEND_ORDER = 'SEND_ORDER';
export const BONG_GROUP_BONGED = 'BONG_GROUP_BONGED';
export const PRINT_SESSION_RECEIPT = 'PRINT_SESSION_RECEIPT';
export const SET_TABLE_ITEMS = 'SET_TABLE_ITEMS';
export const SET_ITEM_TYPE = 'SET_ITEM_TYPE';
export const MOVE_TABLE_ITEMS = 'MOVE_TABLE_ITEMS';
export const ADD_PAYMENT_METHOD = 'ADD_PAYMENT_METHOD';
export const FREEZE_TABLE = 'FREEZE_TABLE';
export const LINK_TABLE_SESSION = 'LINK_TABLE_SESSION';
export const UPDATE_POS_PAYMENT = 'UPDATE_POS_PAYMENT';
export const POS_PAYMENT_META = 'POS_PAYMENT_META';
export const POS_PAYMENT_FAILED = 'POS_PAYMENT_FAILED';
export const POS_PAYMENT_COMPLETED = 'POS_PAYMENT_COMPLETED';
export const CLEAR_ORDER = 'CLEAR_ORDER';
export const REMOVE_POS_PAYMENT = 'REMOVE_POS_PAYMENT';
export const POSPaymentRequest = 'POSPaymentRequest';
export const UpdatePOSPayment = 'UpdatePOSPayment';
export const POSPaymentMeta = 'POSPaymentMeta';
export const POSPaymentFailed = 'POSPaymentFailed';
export const POSPaymentCompleted = 'POSPaymentCompleted';
export const CleareOrder = 'CleareOrder';
export const RemovePOSOrder = 'RemovePOSOrder';
export const REMOVE_POS_ORDER = 'REMOVE_POS_ORDER';
export const JOIN_POS_ORDER = 'JOIN_POS_ORDER';
export const INIT_SPLIT_TABLE = 'INIT_SPLIT_TABLE';
export const SET_SPLIT_TARGET = 'SET_SPLIT_TARGET';
export const CANCEL_TABLE_SPLIT = 'CANCEL_TABLE_SPLIT';
export const TABLE_SPLIT_COMPLETED = 'TABLE_SPLIT_COMPLETED';
export const INIT_SPLIT_TAB = 'INIT_SPLIT_TAB';
export const SET_SPLIT_TABLES_AMOUNT = 'SET_SPLIT_TABLES_AMOUNT';
export const SET_SPLIT_TABLES = 'SET_SPLIT_TABLES';
export const CANCEL_SPLIT_TAB = 'CANCEL_SPLIT_TAB';
export const COMPLETE_SPLIT_TAB = 'COMPLETE_SPLIT_TAB';
export const SYNC_POS_ORDER = 'SYNC_POS_ORDER';
export const POS_ORDER_SYNCED = 'POS_ORDER_SYNCED';
export const SET_POS_MENU = 'SET_POS_MENU';
export const SET_POS_TAKE_AWAY_MENU = 'SET_POS_TAKE_AWAY_MENU';
export const SET_COMPLIANCE_NAME = 'SET_COMPLIANCE_NAME';
export const SET_COMPLIANCE_ID = 'SET_COMPLIANCE_ID';
export const SET_COMPLIANCE_CCU_ID = 'SET_COMPLIANCE_CCU_ID';
export const MESSAGE_TAX_INFORMATION = 'MESSAGE_TAX_INFORMATION';
export const RESET_COMPLIANCE = 'RESET_COMPLIANCE';
export const ERROR = 'ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';
export const MESSAGE_JOURNAL = 'MESSAGE_JOURNAL';
export const MESSAGE_IS_DISCOVERING_PRINTERS = 'MESSAGE_IS_DISCOVERING_PRINTERS';
export const CREATE_SPLIT_POS_ORDER = 'CREATE_SPLIT_POS_ORDER';
export const ADD_PAYMENT_TO_SPLIT_ORDER = 'ADD_PAYMENT_TO_SPLIT_ORDER';
export const REMOVE_PAYMENT_FROM_SPLIT_ORDER = 'REMOVE_PAYMENT_FROM_SPLIT_ORDER';
export const REFUND_SPLIT_PAYMENT = 'REFUND_SPLIT_PAYMENT';
export const FINISH_SPLIT_POS_ORDER = 'FINISH_SPLIT_POS_ORDER';
export const CLEAR_SPLIT_POS_ORDER = 'CLEAR_SPLIT_POS_ORDER';
export const ADD_PRINT_TO_QUEUE = 'ADD_PRINT_TO_QUEUE';
export const CHANGE_PRINT_QUEUE_PRINTER = 'CHANGE_PRINT_QUEUE_PRINTER';
export const PRINT_QUEUE = 'PRINT_QUEUE';
export const PRINT_PHYSICAL_BONG = 'PRINT_PHYSICAL_BONG';
export const PRINT_QUEUE_WITH_ORDER_ID = 'PRINT_QUEUE_WITH_ORDER_ID';
export const CLEAR_RECEIPT = 'CLEAR_RECEIPT';
export const REMOVE_PRINT_FROM_QUEUE = 'REMOVE_PRINT_FROM_QUEUE';
export const MESSAGE_PRINT_BRIDGE_REQUEST_SUCCESS = 'MESSAGE_PRINT_BRIDGE_REQUEST_SUCCESS';
export const MESSAGE_PRINT_BRIDGE_REQUEST_FAILED = 'MESSAGE_PRINT_BRIDGE_REQUEST_FAILED';
export const REPRINT_ON_PRIMARY = 'REPRINT_ON_PRIMARY';
export const SET_LAST_VISITED_PATH = 'SET_LAST_VISITED_PATH';
export const SET_ADYEN_TERMINALS = 'SET_ADYEN_TERMINALS';
export const ADD_TABLE_EVENT = 'ADD_TABLE_EVENT';
export const CHANGE_ALWAYS_PRINT = 'CHANGE_ALWAYS_PRINT';
export const ADD_TOAST = 'ADD_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';
export const SET_LAST_USED_POS_MODE = 'SET_LAST_USED_POS_MODE';
export const LOG_EVENT_COUNT = 'LOG_EVENT_COUNT';
export const SEND_ONLINE_ORDER = 'SEND_ONLINE_ORDER';
export const SET_TRACE_ID = 'SET_TRACE_ID';
export const SET_DEMO_MODE = 'SET_DEMO_MODE';
export const SET_COUNTRY = 'SET_COUNTRY';
export const SET_COMPANY_TIMEZONE = 'SET_COMPANY_TIMEZONE';
export const SET_DEFAULT_LANGUAGE = 'SET_DEFAULT_LANGUAGE';
export const SET_ENABLE_MODIFICATIONS = 'SET_ENABLE_MODIFICATIONS';
export const SET_BEEPER_LIST = 'SET_BEEPER_LIST';
export const SET_USE_AUTO_CASH_EOD = 'SET_USE_AUTO_CASH_EOD';
export const SAVE_BONG_PRINT = 'SAVE_BONG_PRINT';
export const SET_PREDEFINED_REASONS = 'SET_PREDEFINED_REASONS';
export const SET_BOOKING_DISCOUNT_CATEGORY_IDS = 'SET_BOOKING_DISCOUNT_CATEGORY_IDS';

export function addTableEvent(event: TableEvent) {
  return {
    type: 'ADD_TABLE_EVENT',
    event,
  };
}

export function addInventoryEvent(event: InventoryEvent) {
  return {
    type: 'ADD_INVENTORY_EVENT',
    event,
  };
}

export function addReportsEvent(event: ReportEvent) {
  return {
    type: 'ADD_REPORT_EVENT',
    event,
  };
}

export function addOrderStatusEvent(event: OrderStatusEvent) {
  return {
    type: 'ADD_ORDER_STATUS_EVENT',
    event,
  };
}
/* XYZ */
export function addCashEvent(event: CashEvent) {
  return {
    type: 'ADD_CASH_EVENT',
    event,
  };
}

export function addDeviceSettingsEvent(event: DeviceSettingsEvent) {
  return {
    type: 'ADD_DEVICE_SETTINGS_EVENT',
    event,
  };
}

export function staffLogin(id: string, code: string, name: string) {
  return {
    type: POS_STAFF_LOGIN,
    id,
    code,
    name,
  };
}

export function staffLogout() {
  return {
    type: POS_STAFF_LOGOUT as typeof POS_STAFF_LOGOUT,
  };
}

export function setCompanyStaff(companyId: string, staffs: getCompany_Venue_company_staffs[]) {
  return {
    type: SET_COMPANY_STAFF,
    companyId,
    staffs,
  };
}

export function resetCompanyStaff() {
  return {
    type: RESET_COMPANY_STAFF,
  };
}

export function toggleMainMenu(isShow: boolean) {
  return {
    type: TOGGLE_MAIN_MENU as typeof TOGGLE_MAIN_MENU,
    isShow,
  };
}

export function setToken(authToken: AuthToken) {
  return {
    type: SET_TOKEN as typeof SET_TOKEN,
    authToken,
  };
}
export function setDailyTotal(dailyTotal: number) {
  return {
    type: SET_DAILY_TOTAL,
    dailyTotal,
  };
}

export function setOrdersCount(count: number) {
  return {
    type: SET_ORDERS_COUNT,
    count,
  };
}

export function incomingOrder() {
  return {
    type: NEW_INCOMING_ORDER,
  };
}

export function userProvidedInput() {
  return {
    type: USER_PROVIDED_INPUT,
  };
}

export function changeLocale(languageLocale: Locale) {
  return {
    type: CHANGE_LOCALE,
    locale: languageLocale,
  };
}

export function changeLanguage(language: Languages) {
  return {
    type: CHANGE_LANGUAGE,
    language,
  };
}

export function setOrderDetailsId(orderDetailsId: string | null) {
  return {
    type: SET_ORDER_DETAILS_ID,
    orderDetailsId,
  };
}

export function setCollapsedTable(sessionId: string) {
  return {
    type: SET_COLLAPSED_TABLE,
    sessionId,
  };
}

export function unsetCollapsedTable(sessionId: string) {
  return {
    type: UNSET_COLLAPSED_TABLE,
    sessionId,
  };
}

export function setConnectionStatus(offline: boolean) {
  return {
    type: SET_CONNECTION_STATUS,
    offline,
  };
}

export function socketPongReceived(latencyMs: number) {
  return {
    type: SOCKET_PONG_RECEIVED,
    latencyMs,
  };
}

export function socketConnectionLost() {
  return {
    type: SOCKET_CONNECTION_LOST,
  };
}

export function setUser(user: User) {
  return {
    type: SET_USER,
    user,
  };
}

export function setCompany(companyId: string) {
  return {
    type: SET_COMPANY,
    companyId,
  };
}

export function setCompanyName(companyName: string) {
  return {
    type: SET_COMPANY_NAME,
    companyName,
  };
}

// integrations has type any in file ./Scenes/Venue/__queries__/getIntegrations.ts
export function setActiveIntegrations(integrations: any[]) {
  return {
    type: SET_ACTIVE_INTEGRATIONS,
    integrations,
  };
}
export function setPOSItemsIds(
  itemIds: POSItemsIdsState,
): {
  type: typeof SET_POS_ITEMS_IDS;
  itemIds: POSItemsIdsState;
} {
  return {
    type: SET_POS_ITEMS_IDS as typeof SET_POS_ITEMS_IDS,
    itemIds,
  };
}

export function setStations(stations: Station[]) {
  return {
    type: SET_STATIONS,
    stations,
  };
}

export function setStation(id: string | null) {
  return {
    type: SET_STATION,
    id,
  };
}

export function resetStation() {
  return {
    type: RESET_STATION,
  };
}

export function setZones(zones: Zone[]) {
  return {
    type: SET_ZONES,
    zones,
  };
}

export function setFloorPlans(floorPlans: GetTables_Venue_floorPlans[]) {
  return {
    type: SET_FLOOR_PLANS,
    floorPlans,
  };
}

export function setTables(tables: GetTables_Venue_floorPlans_tables[]) {
  return {
    type: SET_TABLES,
    tables,
  };
}

export function setPredefinedMessages(predefinedMessages: getCompany_Venue_predefinedMessages[]) {
  return {
    type: SET_PREDEFINED_MESSAGES,
    predefinedMessages,
  };
}

export function setCourseTypes(courseTypes: CourseType[]) {
  return {
    type: SET_COURSE_TYPES,
    courseTypes,
  };
}

type Order = Omit<CreatePOSOrder, 'type'>;
interface InitiateOrderState extends Order {
  serviceType: SERVICE_TYPE;
  method: string;
}

export function initiateOrder(order: InitiateOrderState) {
  return {
    type: CREATE_POS_ORDER,
    ...order,
  };
}
export function updateOrder(id: string, order: Order) {
  return {
    type: UPDATE_POS_ORDER as typeof UPDATE_POS_ORDER,
    id,
    order,
  };
}

export function addItemToOrder(orderId: string, item: Optional<CartItem, 'id'>) {
  return {
    type: ADD_ITEM_TO_POS_ORDER as typeof ADD_ITEM_TO_POS_ORDER,
    item,
    id: orderId,
  };
}

export function removeItemFromOrder(orderId: string, id: string) {
  return {
    type: REMOVE_ITEM_FROM_POS_ORDER,
    orderId: orderId,
    id: id,
  };
}

export function removeLegalItemSFromOrder(orderId: string) {
  return {
    type: REMOVE_LEGAL_ITEMS_FROM_POS_ORDER,
    orderId: orderId,
  };
}

export function updatePaymentMeta(paymentId: string, meta: Partial<Meta>) {
  return {
    type: POS_PAYMENT_META,
    id: paymentId,
    meta,
  };
}

export function initiatePayment(
  orderId: string,
  payment: {
    id?: string;
    method: string;
    disableTip?: boolean;
    variant?: string;
    canCancel: boolean;
    amount: number;
    meta?: Meta;
  },
) {
  return {
    type: POS_PAYMENT_REQUEST as typeof POS_PAYMENT_REQUEST,
    order: orderId,
    ...payment,
  };
}

export function setModulesWebpage(url: string | null) {
  return {
    type: SET_MODULES_WEBPAGE as typeof SET_MODULES_WEBPAGE,
    url,
  };
}

export function overridePaymentMethod(paymentId: string, method: string) {
  return {
    type: OVERRIDE_POS_PAYMENT_METHOD as typeof OVERRIDE_POS_PAYMENT_METHOD,
    paymentId,
    method,
  };
}

type AddPrintToQueue = {
  printer: string;
  printerModel: string;
  orderId?: string;
  sessionId?: string;
  data?: string | PrintRow[];
  printType?: PrintType;
  reprintOfPrintId?: string;
  base64Image?: string;
};
export function addPrintToQueue(print: AddPrintToQueue) {
  return {
    type: ADD_PRINT_TO_QUEUE as typeof ADD_PRINT_TO_QUEUE,
    ...print,
  };
}

export function addVirtualTestPrinter(printer: Printer) {
  return {
    type: ADD_VIRTUAL_TEST_PRINTER as typeof ADD_VIRTUAL_TEST_PRINTER,
    printer,
  };
}

export function changePrintQueuePrinter(id: string, printer: string) {
  return {
    type: CHANGE_PRINT_QUEUE_PRINTER as typeof CHANGE_PRINT_QUEUE_PRINTER,
    id,
    printer,
  };
}

export function printQueue(id: string) {
  return {
    type: PRINT_QUEUE as typeof PRINT_QUEUE,
    id,
  };
}

export function printQueueWithOrderId(orderId: string) {
  return {
    type: PRINT_QUEUE_WITH_ORDER_ID as typeof PRINT_QUEUE_WITH_ORDER_ID,
    orderId,
  };
}

export function removePrintFromQueue(id: string) {
  return {
    type: REMOVE_PRINT_FROM_QUEUE as typeof REMOVE_PRINT_FROM_QUEUE,
    id,
  };
}

export function reprintOnPrimary(id: string) {
  return {
    type: REPRINT_ON_PRIMARY as typeof REPRINT_ON_PRIMARY,
    id,
  };
}

/**
 * Where a toast is shown. 'default' uses the route-based position in `Components/Toasts`
 * (bottom-right on POS/Tables). 'top' forces the top of the screen, for toasts triggered
 * from modals whose bottom bar the default position would cover.
 */
export type ToastPlacement = 'default' | 'top';

export function addToast(
  message: string,
  autoRemove: boolean,
  id?: string | null,
  isError?: boolean,
  action?: {
    label: string;
    onClick: () => void;
  },
  loading?: boolean,
  placement: ToastPlacement = 'default',
) {
  return {
    type: ADD_TOAST,
    id: id ?? uuid(),
    message,
    autoRemove,
    isError: Boolean(isError),
    action,
    loading: Boolean(loading),
    placement,
  };
}

export function removeToast(id: string) {
  return {
    type: REMOVE_TOAST,
    id,
  };
}

export function setLastUsedPosMode(mode: PosMode) {
  return { type: SET_LAST_USED_POS_MODE, mode };
}

export function setTraceId(id: string) {
  return {
    type: 'SET_TRACE_ID',
    id,
  };
}

export function setDemoMode(state: boolean) {
  return {
    type: 'SET_DEMO_MODE',
    state,
  };
}

export function setCountry(state: CountryCode | null) {
  return {
    type: 'SET_COUNTRY',
    state,
  };
}

export function setCompanyTimezone(companyTimeZone: string) {
  return {
    type: 'SET_COMPANY_TIMEZONE',
    companyTimeZone,
  };
}

export function setDefaultLanguage(state: Languages | null) {
  return {
    type: 'SET_DEFAULT_LANGUAGE',
    state,
  };
}

export function addError(state: Omit<ErrorCase, 'type'>) {
  return {
    type: ERROR,
    orderId: state.orderId,
    errorType: state.errorType,
    title: state.title,
    message: state.message,
  };
}

export function clearError(id: string) {
  return {
    type: CLEAR_ERROR,
    id,
  };
}

export function clearAllErrors() {
  return {
    type: CLEAR_ALL_ERRORS,
  };
}

export function setPredefinedReasons(state: getCompany_Venue_company_predefinedReasons[]) {
  return {
    type: SET_PREDEFINED_REASONS,
    state,
  };
}

export function setBookingDiscountCategoryIds(state: string[]) {
  return {
    type: SET_BOOKING_DISCOUNT_CATEGORY_IDS,
    state,
  };
}
